import React, { useEffect, useState } from "react";

type Props = {
  className?: string;
  defaultValue?: any;
  name?: string;
  id?: string;
  handleChange?: any;
  onBlur?: any;
};

const InputCheckbox: React.FC<Props> = ({
  className,
  defaultValue,
  name,
  id,
  handleChange,
  onBlur,
}) => {
  if (typeof defaultValue !== "boolean") {
    defaultValue = false;
  }

  const [isChecked, setIsChecked] = useState(defaultValue);

  useEffect(() => {
    setIsChecked(defaultValue);
  }, [defaultValue]);

  return (
    <label className="form-check form-check-inline form-check-solid me-5">
      <input
        className={`form-check-input ${className}`}
        type="checkbox"
        checked={isChecked}
        style={{ cursor: "pointer" }}
        id={id}
        name={name}
        onChange={(e) => setIsChecked(e.target.checked)}
        onClick={handleChange}
        onBlur={onBlur}
      />
      <span className="fw-bold ps-2 fs-6"></span>
    </label>
  );
};

export { InputCheckbox };
